import React from 'react';
import PropTypes from 'prop-types';

import '../styles/RegisterMenu.css';

import FirstLevelMenu from './FirstLevelMenu';
import SecondLevelMenu from './SecondLevelMenu';
import {ReactComponent as MyMenu} from '../icons/my-menu-icon.svg';

const RegisterMenu = ({ settings }) => {
    const firstLevelMenuForRegister = ["Camera Setup", "Custom Picture/HDR", "Recording/Media Setup", "Audio Setup", "Monitoring Setup", "Assistance Functions", "Network Settings", "Assignable Buttons", "System Setup", "My menu", "Close"]
    const secondLevelMenu = ["1", "2", "3", "4", "5", "6"];
    const list = ["Iris Mode", "Iris Increment", "Fine Increment", "Zoom Iris Correct", "Extended ND Range"];
    return (
      <>
        <div className="Register-title">
          <MyMenu className="Icon-menu" />
          {settings.title}
        </div>
        <FirstLevelMenu menuLevel={1} firstLevelMenu={firstLevelMenuForRegister} firstLevelIndex={0} />
        <SecondLevelMenu menuLevel={1} secondLevelMenu={secondLevelMenu} secondLevelIndex={0} parentItemName={"Camera Setup"}/>
        <ul className="Third-level-menu List-menu">
          {list.map((el) => <li key={el} className="Third-level-item List-item">{el}</li>)}
        </ul>
      </>
    )
  }
  
RegisterMenu.propTypes = {
    settings: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default RegisterMenu;